import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(PerfectScrollbarPlugin);
});
